<!--US Page-->
<style>

  .mbfs-home-hero_2{
    height: 545px;
  }
  @media (max-width: 768px) {
    .mbfs-home-hero_2{
      height: 1000px;
    }
  }
  .mbfs-repay-banner-inner {
    padding: 40px 20px;
  }

  .mbfs-repay-banner-inner .row {
    display: flex;
    justify-content: center;
    align-items: center;
    max-width: 1200px;
    margin: 0 auto;
    flex-wrap: wrap;
    /* for mobile */
  }

  /* Columns */
  .mbfs-repay-banner-inner .col-5 {
    flex: 0 0 50%;
    max-width: 50%;
    padding: 20px;
    box-sizing: border-box;
  }

  /* Left align text */

  .mbfs-repay-banner-inner h2,
  .mbfs-repay-banner-inner p,
  .mbfs-repay-banner-inner ul {
    text-align: left;
  }

  /* Improve list font size */

  .mbfs-repay-banner-inner ul {
    font-size: 16px;
    line-height: 1.6;
    padding-left: 20px;
    list-style-type: disc;
    color: black;
    /* controls bullet color */
  }

  /* Images */

  .mbfs-repay-banner-inner img {
    max-width: 100%;
    height: auto;
    display: block;
  }

  /* Last section image size control */

  .mbfs-repay-banner-inner:last-of-type img {
    max-width: 100%;
    height: auto;
    object-fit: contain;
  }

  /* Center align middle section image */

  .mbfs-repay-banner-inner:nth-of-type(2) {
    text-align: center;
  }

  .mbfs-repay-banner-inner:nth-of-type(2) img {
    margin: 0 auto;
    max-width: 90%;
  }

  /* Video styling */

  video {
    width: 100%;
    height: auto;
  }

 @media (max-width: 768px) {

  /* Stack layout (keep order same) */
  .mbfs-home-hero_2__header {
    flex-direction: column !important;
    gap: 20px !important;
  }

  /* Heading smaller */
  .mbfs-home-hero_2__header h2 {
    font-size: 32px !important;
    line-height: 1.2;
  }

  /* Subtitle smaller */
  .mbfs-home-hero_2__header p {
    font-size: 18px !important;
  }

  /* Logos stay in one row */
  .mbfs-home-hero_2__header div[style*="display: flex"][style*="align-items: center"] {
    flex-wrap: nowrap !important;
    justify-content: flex-start;
    gap: 10px !important;
  }

  .logos{
    flex-wrap: nowrap !important;
    justify-content: flex-start;
    gap: 10px !important;
    width: 200px;
    margin: 65px;
    margin-top: 0px;
    margin-bottom: 0px;
  }

  /* Smaller logos */
  .mbfs-home-hero_2__header img {
    max-width: 40% !important;
  }

  /* Divider smaller */
  .mbfs-home-hero_2__header div[style*="width: 2px"] {
    height: 40px !important;
  }

  /* Reduce padding */
  .mbfs-home-hero_2__header > div {
    padding: 10px !important;
  }

}
  /* Mobile responsive */

  @media (max-width: 768px) {
    .mbfs-repay-banner-inner .col-5 {
      flex: 0 0 100%;
      max-width: 100%;
      text-align: center;
    }

    .mbfs-repay-banner-inner p,
    .mbfs-repay-banner-inner ul {
      text-align: left;
    }

    .mbfs-repay-banner-inner ul {
      font-size: 15px;
    }

    .mbfs-repay-banner-inner h2{
      text-align: center;
      font-size: 25px;
    }
    h2{
      text-align: center;
      font-size: 25px;
    }
  }

  .faq-container {
    max-width: 1000px;
    margin: auto;
    padding: 10px;
  }

  .faq-item {
    background: #fff;
    margin-bottom: 10px;
    border-radius: 8px;
    overflow: hidden;
    box-shadow: 0 2px 6px rgba(0, 0, 0, 0.1);
  }

  .faq-question {
    padding: 15px;
    display: flex;
    justify-content: space-between;
    cursor: pointer;
    font-weight: 600;
    font-size: 16px;
  }

  .icon {
    font-size: 20px;
    transition: transform 0.3s;
  }

  .faq-answer {
    max-height: 0;
    overflow: hidden;
    padding: 0 15px;
    transition: all 0.3s ease;
    font-size: 14px;
    color: #555;
  }

  .faq-answer.open {
    max-height: 335px;
    padding: 15px;
  }

  /* Style the list inside FAQ answers */
.faq-answer ul {
  list-style-type: disc !important;       /* solid circle bullets */
  padding-left: 20px;          /* indent the list */
  margin-top: 8px;             /* space from the previous text */
}

.faq-answer li {
  margin-bottom: 6px;          /* space between each bullet */
  color: black;                /* text color */
}

  /* Mobile Responsive */
  @media (max-width: 768px) {
    .faq-question {
      font-size: 14px;
      padding: 12px;
    }

    .faq-answer {
      font-size: 13px;
    }
  }

  footer [role=contentinfo] .mbfs-copyright {
    display: flex;
    justify-content: center;
    width: 100%;
  }

  @media (max-width: 768px) {
    .mbfs-home-hero_2__header {
      flex-direction: column !important;
    }

    .mbfs-home-hero_2__header>div {
      max-width: 100% !important;
      flex: 100% !important;
      text-align: center;
    }

    .mbfs-home-hero_2__header h2,
    .mbfs-home-hero_2__header p {
      text-align: center !important;
    }

    /* Images stack nicely */
    .mbfs-home-hero_2__header img {
      max-width: 80% !important;
      margin: 0 auto;
    }

    /* Divider becomes horizontal */
    .mbfs-home-hero_2__header div[style*="background-color: black"] {
      width: 60px !important;
      height: 2px !important;
    }

    /* Image container center */
    .mbfs-home-hero_2__header>div>div:last-child {
      justify-content: center !important;
    }
  }

  .video-container {
    position: relative;
    width: fit-content;
  }

  video {
    display: block;
  }

  /* Circle button */
  .play-btn {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);

    width: 70px;
    height: 70px;
    border-radius: 50%;

    border: 2px solid white;
    background: transparent;

    display: flex;
    align-items: center;
    justify-content: center;

    cursor: pointer;
  }

  /* Triangle (play icon) */
  .triangle {
    width: 0;
    height: 0;
    border-left: 18px solid white;
    border-top: 10px solid transparent;
    border-bottom: 10px solid transparent;
    margin-left: 4px;
    /* slight visual centering */
  }
  /* Default styles remain as-is */

 @media (max-width: 768px) {
  .mbfs-repay-banner-inner__box > div {
    flex-wrap: nowrap !important; /* prevent stacking */
    flex-direction: row !important;
    align-items: center;
    justify-content: center;
    gap: 10px !important; /* tighter spacing */
  }

  /* Image smaller */
  .mbfs-repay-banner-inner__box img {
    width: 70px !important;
    height: auto;
  }

  /* Force image container small */
  .mbfs-repay-banner-inner__box > div > div:first-child {
    flex: 0 0 70px !important;
  }

  /* Text container takes remaining space */
  .mbfs-repay-banner-inner__box > div > div:last-child {
    flex: 1 !important;
    min-width: 0; /* prevents overflow */
  }

  /* Smaller text */
  .mbfs-repay-banner-inner__box h3 {
    font-size: 16px !important;
    margin-bottom: 4px;
  }

  .mbfs-repay-banner-inner__box h5 {
    font-size: 12px !important;
    line-height: 1.3;
  }

  /* Remove extra breaks */
  .mbfs-repay-banner-inner__box br {
    display: none;
  }

  .mbfs-repay-banner-inner {
    padding: 15px 10px !important;
  }
}
 /* Step container */
.step {
  display: flex;
  flex-direction: column;
  align-items: center;
  text-align: center;
  padding: 10px; 
  padding-left: 40px;  
  padding-right: 40px;        /* small space around each */
  min-height: 160px;       /* force all steps to same height */
  justify-content: flex-start;
}

/* Text */
.step p {
  margin-top: 10px;
  font-weight: bold;
  color: #00566A;
  white-space: nowrap;     /* prevent wrapping */
  overflow: hidden;        /* truncate if really long */
  text-overflow: ellipsis; /* show ... if truncated */
}
@media (max-width: 760px) {
  .col-6 {
    flex: 0 0 100%;
    max-width: 100%;
  }
}
</style>

<div class="dtfinsurance" *ngIf="!isCanadaPortal">

  <!--Banner-->
  <section class="mbfs-home-hero_2" style="background-color: #C8C8C8; padding: 0px 15px;">
    <section class="mbfs-home-hero_2__header"
      style="max-width: 1360px; margin: 0 auto; display: flex; flex-wrap: wrap; gap: 100px; padding: 0px;">
      <!-- LEFT SIDE -->
      <div
        style="flex: 1 1 500px; max-width: 600px; padding: 20px; box-sizing: border-box; display: flex; flex-direction: column; justify-content: space-between;">
        <!-- Text -->
        <div>
          <h2 style="text-align: left; margin-bottom: 15px; font-size: 60px; font-family: 'corporateSDemiRegular';">
            {{ 'ConnectInsuranceLead.title' | translate }}
          </h2>
          <p style="text-align: left; margin-bottom: 20px; font-size: 28px; color: black;">
            {{ 'ConnectInsuranceLead.subtitle' | translate }}
          </p>
        </div>
        <!-- Bottom Images -->
        <div class="logos" style="display: flex; align-items: center; gap: 15px; margin-top: 20px; flex-wrap: wrap;">
          <img src="/static/assets/img/dtf-assets/images/redesign/logo_heritageblue.png" alt="img1"
            style="max-width: 45%; height: auto; object-fit: contain;">
          <!-- Divider -->
          <div style="width: 2px; height: 60px; background-color: black;"></div>
          <img
            src="/static/assets/img/dtf-assets/images/redesign/DTF_InsuranceAgency_Wordmark-Stacked_Blk_NoTagline-LLC.png"
            alt="img2" style="max-width: 45%; height: auto; object-fit: contain;">
        </div>
      </div>
      <!-- RIGHT SIDE (FORM) -->
      <div
        style="flex: 1 1 400px; max-width: 600px; padding: 20px; box-sizing: border-box; display: flex; align-items: center; justify-content: center;">
        <div class="dtf-connectedinsuranceleadform" style="width: 100%;"></div>
      </div>
    </section>
  </section>



  <section class='mbfs-repay-banner-inner' style="background-color: white;">
    <div class="row" style="align-items: left; display: flex; justify-content: center;">
      <div class="col-5">
    <video controls  poster="/static/assets/img/dtf-assets/images/redesign/Connected Insurance Video - Desktop.png" #videoPlayer class="hero-video" muted loop playsinline preload="auto" (click)="playVideo(videoPlayer)"
      (play)="onVideoPlay()" (pause)="isPlaying = false">
    
      <source src="/static/videos/DTIA-GEICO-Homepage.mp4" type="video/mp4">
    </video>
    
    <button *ngIf="!isPlaying" class="play-btn" (click)="playVideo(videoPlayer)">
      <span class="triangle"></span>
    </button>
      </div>
      <div class="col-5">
        <h2 style="font-family: 'corporateSDemiRegular';">What Is Connected Insurance?</h2>
        <p style="color: black;">Connected Insurance is a data integrated insurance solution Daimler Truck Insurance
          Agency* (DTIA) developed in partnership with GEICO. It is designed to help owner-operators and small fleets
          potentially save on their insurance premiums when they elect to share their Detroit Connect® data directly with
          GEICO, without installing tracking hardware.</p>
      </div>
    </div>
  </section>

  <br>

  <section class='mbfs-repay-banner-inner' style="background-color: #E6E6E6; display: flex; justify-content: center;">
    <div class="mbfs-repay-banner-inner__box">
      <div class="mbfs-repay-banner-inner__box--text2">
        <div class="container">
          <div class="row text-center g-4">
        
            <div class="col-6 col-md-3 step d-flex flex-column align-items-center">
              <img src="/static/assets/img/dtf-assets/images/redesign/connectedinfographic_1.png" alt="">
              <p>Get Quote</p>
            </div>
        
            <div class="col-6 col-md-3 step d-flex flex-column align-items-center">
              <img src="/static/assets/img/dtf-assets/images/redesign/connectedinfographic_2.png" alt="">
              <p>Share Your Data</p>
            </div>
        
            <div class="col-6 col-md-3 step d-flex flex-column align-items-center">
              <img src="/static/assets/img/dtf-assets/images/redesign/connectedinfographic_3.png" alt="">
              <p>Activate Coverage</p>
            </div>
        
            <div class="col-6 col-md-3 step d-flex flex-column align-items-center">
              <img src="/static/assets/img/dtf-assets/images/redesign/connectedinfographic_4.png" alt="">
              <p>Start Saving</p>
            </div>
        
          </div>
        </div>
      </div>
    </div>
  </section>

  <br>

  <section class='mbfs-repay-banner-inner' style="background-color: white;">
    <div class="row" style="align-items: left; display: flex; justify-content: center;">
      <div class="col-5">
        <h2 style="font-family: 'corporateSDemiRegular';"> The Benefits at a Glance </h2>

        <ul style="color: black; ">
          <li>Save up to 10% on insurance premiums, excluding fees and taxes</li>
          <li>No need to install additional hardware</li>
          <li>Enhanced underwriting and claims accuracy </li>
          <li>Tailored for Freightliner® and Western Star® customers</li>
          <li>Customizable insurance protection backed by more than 85 years of insurance expertise</li>
        </ul>

      </div>

      <div class="col-5">
        <img src="/static/assets/img/dtf-assets/images/redesign/truck image.png" alt="">
      </div>
    </div>
  </section>

  <br>

 <section class='mbfs-repay-banner-inner' 
  style="background-color: #E6E6E6; padding: 40px 20px; display: flex; justify-content: center;">
  
  <div class="mbfs-repay-banner-inner__box" 
       style="max-width: 1600px; width: 100%; margin: 0 auto; text-align: center;">
    
    <div style="display: flex; align-items: center; justify-content: center; gap: 60px; flex-wrap: wrap;">
      
      <!-- Image -->
      <div style="flex: 0 0 220px;">
        <img src="/static/assets/img/dtf-assets/images/redesign/gecko_waving_11in.png"
             style="width: 200px; height: auto;">
      </div>

      <!-- Text -->
      <div style="flex: 1; text-align: center;">
        <h3 style="margin-bottom: 10px; color: black; font-size: 40px; font-weight: 600; font-family: 'corporateSRegular';">
          Ready to Save on Your Insurance?
        </h3>
        <br><br>
        <h5 style="color: black; line-height: 1.6; font-size: 32px; font-family: 'corporateSRegular';">
          Submit the form above to get started on your personalized quote.
        </h5>

        <h5 style="color: black; line-height: 1.6; font-size: 32px; font-family: 'corporateSRegular';">
          Questions or need help? Call
          <a href="tel:1-800-909-1184" (click)="onPhoneClick()">1-800-909-1184</a>
          to start saving today.
        </h5>
      </div>

    </div>
  </div>
</section>


  <br>

  <footer id="mbfs-footer" style="box-shadow: none;">
    <div role="contentinfo" style="display: flex;">
      <div class="mbfs-copyright">
        <p class="paragraph1"> {{ 'Insurance.DisclaimerConnectedInsurance' | translate }} </p>
        <p class="paragraph1"> {{ 'Insurance.Disclaimer2' | translate }} </p>
      </div>
    </div>
  </footer>

  <br>

  <div class="faq-container">
    <h2 style="font-family: 'corporateSDemiRegular';">Frequently Asked Questions</h2>
    <br>
    <div class="faq-item" *ngFor="let faq of faqs; let i = index" [class.active]="faq.isOpen">
      <div class="faq-question" (click)="toggleFaq(i)">
        <span>{{ faq.question }}</span>
        <span class="icon">
          {{ faq.isOpen ? '−' : '+' }}
        </span>
      </div>

      <div class="faq-answer" [class.open]="faq.isOpen">
        <p style="color: black;" [innerHTML]="faq.answer"></p>
      </div>
    </div>
  </div>

  <br>

  

</div>